import * as React from 'react';

import { IRootState, RootAction, ISnackbarNotification, DispatchRemoveSnackbar } from '../../@types/redux';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { withSnackbar, WithSnackbarProps } from 'notistack';
import { removeSnackbar } from '../../store/general/Actions';
import IconButton from '@mui/material/IconButton';
import Icon from '@mui/material/Icon';

interface ISnackbarNotifierProps extends WithSnackbarProps {
    notifications : Array<ISnackbarNotification>;

    removeSnackbar : DispatchRemoveSnackbar;
}

class SnackbarNotifier extends React.Component<ISnackbarNotifierProps> {
    private displayed : Array<number> = [];

    private storeDisplayed = (id : number) => {
        this.displayed = [...this.displayed, id];
    };

    public shouldComponentUpdate = ({ notifications: newSnacks = [] as Array<ISnackbarNotification> }) => {
        const { notifications: currentSnacks } = this.props;
        const notExists = currentSnacks.every(({ key }) => newSnacks.some(n => n.key === key));
        return notExists;
    };

    public componentDidUpdate = () => {
        const { notifications = [] } = this.props;

        notifications.forEach((notification) => {
            // Do nothing if snackbar is already displayed
            if (this.displayed.some(x => x === notification.key)) return;
            // Display snackbar using notistack
            this.props.enqueueSnackbar(notification.message, {
                key: `snackbar_${notification.key}`,
                action: <IconButton onClick={() => { this.props.closeSnackbar(`snackbar_${notification.key}`); }}>
                    <Icon className={'cw'}>close</Icon>
                </IconButton>,
                ...notification.options,
            });
            // Keep track of snackbars that we've displayed
            this.storeDisplayed(notification.key);
            // Dispatch action to remove snackbar from redux store
            this.props.removeSnackbar(notification.key);
        });
    };

    public render = () => {
        return null;
    };
}

const mapStateToProps = (state : IRootState) => {
    return {
        notifications: state.general.notifications,
    };
};

const mapDispatchToProps = (dispatch : Dispatch<RootAction>) => bindActionCreators(
    { removeSnackbar }, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withSnackbar(SnackbarNotifier));
